import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import './CategoryHeader.css';

// Descripciones para filtros de tipo de piel
const SKIN_TYPE_INFO = {
  'Normal': {
    title: 'Piel Normal',
    description: 'Productos diseñados para mantener el equilibrio natural de tu piel, preservando su hidratación y luminosidad.'
  },
  'Seca': {
    title: 'Piel Seca',
    description: 'Fórmulas ricas en activos hidratantes y nutritivos que restauran la barrera cutánea y aportan confort duradero.'
  },
  'Grasa': {
    title: 'Piel Grasa',
    description: 'Texturas ligeras con activos seborreguladores que controlan el exceso de sebo sin resecar la piel.'
  },
  'Mixta': {
    title: 'Piel Mixta',
    description: 'Formulaciones equilibrantes que hidratan las zonas secas y regulan las áreas con mayor producción de sebo.'
  },
  'Sensible': {
    title: 'Piel Sensible',
    description: 'Productos formulados con ingredientes calmantes y sin irritantes, ideales para pieles reactivas o con tendencia al enrojecimiento.'
  },
};

// Descripciones para preocupaciones de la piel
const CONCERN_INFO = {
  'Acné': {
    title: 'Acné',
    description: 'Tratamientos con activos antibacterianos y exfoliantes que ayudan a controlar los brotes y prevenir marcas.'
  },
  'Manchas': {
    title: 'Manchas',
    description: 'Activos despigmentantes y antioxidantes que unifican el tono de la piel y previenen la hiperpigmentación.'
  },
  'Arrugas': {
    title: 'Arrugas',
    description: 'Fórmulas con péptidos y retinoides que estimulan la producción de colágeno y reducen las líneas de expresión.'
  },
  'Poros dilatados': {
    title: 'Poros dilatados',
    description: 'Productos con ácidos y niacinamida que refinan la textura y minimizan la apariencia de los poros.'
  },
  'Luminosidad': {
    title: 'Luminosidad',
    description: 'Antioxidantes y vitamina C que devuelven la vitalidad y el brillo natural a tu piel.'
  },
  'Hidratación': {
    title: 'Hidratación',
    description: 'Ácido hialurónico y ceramidas que retienen la humedad y fortalecen la barrera cutánea.'
  },
};

export default function CategoryHeader({ handle, getCategoryByHandle }) {
  const [searchParams] = useSearchParams();

  const headerData = useMemo(() => {
    // Verificar si hay filtro de tipo de piel
    const skinFilter = searchParams.get('skin');
    if (skinFilter) {
      const skinInfo = SKIN_TYPE_INFO[skinFilter];
      if (skinInfo) return skinInfo;
      return { title: `Piel ${skinFilter}`, description: '' };
    }

    // Verificar si hay filtro de preocupación
    const concernFilter = searchParams.get('concern');
    if (concernFilter) {
      const concernInfo = CONCERN_INFO[concernFilter];
      if (concernInfo) return concernInfo;
      return { title: concernFilter, description: '' };
    }

    // Fallback a categoría
    const category = getCategoryByHandle(handle);
    if (category) {
      return { title: category.name, description: category.description };
    }

    return null;
  }, [handle, getCategoryByHandle, searchParams]);

  if (!headerData) return null;

  const key = searchParams.get('skin') || searchParams.get('concern') || handle;
  const isAllProducts = !searchParams.get('skin') && !searchParams.get('concern') && (!handle || handle === 'todo');

  return (
    <div
      className={`category-header-section${isAllProducts ? ' category-header-section--halloween' : ''}`}
      key={key}
    >
      {isAllProducts && (
        <img
          className="category-header-bg"
          src="/images/products/Happy_halloween_portada_shop.webp"
          alt=""
          aria-hidden="true"
          loading="eager"
          decoding="async"
        />
      )}
      <div className="category-header-content">
        <h1 className="category-header-title">{headerData.title}</h1>
        {headerData.description && (
          <p className="category-header-desc">{headerData.description}</p>
        )}
      </div>
    </div>
  );
}
